import Store from '@/vuex/store';

export const showControlHelper = (module: string, show: any[], formState?: any, controlName?: string, policy?: any | null): boolean => {
    if (!show) return true;

    let showResult = false;
    let isSubFormRule = false;

    // Show conditions are arrays of arrays. Each array within the array is an OR condition containing checks that all must be true
    try {
        show.forEach((showConditions: any[]) => {
            // loop through the set of OR conditions
            let result = true;

            showConditions.forEach((showCondition: any) => {
                // Loop through the inner AND conditions

                let value: any = null;
                if (showCondition.location == 'SubForm' && formState) {
                    // Used for SubFormTable showing
                    value = formState[showCondition.name];
                    isSubFormRule = true;
                } else if (showCondition.location == 'Submission') {
                    value = Store.getters.getSubmissionValue(showCondition.name);
                } else {
                    value = Store.getters.getControlValue(module, showCondition.name);
                    if (value === null || value === undefined) {
                        // uses two way data binding to see if the data is on the submission instead of the control
                        value = Store.getters.getSubmissionDataValue(showCondition.name);
                    }

                    // there is a race condition during endorsement data binding where we can check if a control is supposed to be shown before the data is bound to the control
                    // so if the value is null, check the policy for the value
                    if (policy != null && policy !== undefined && (value === null || value === undefined)) {
                        value = policy[showCondition.name].value;
                    }
                }

                if (showCondition.type == 'UserRoleInList') {
                    const userRole = Store.getters.getUserRole;
                    if (showCondition.value && showCondition.value.indexOf(userRole) == -1) result = false;
                } else if (showCondition.type == 'EqualTo') {
                    if (value === undefined || value !== showCondition.value) result = false;
                } else if (showCondition.type == 'GreaterThan') {
                    if (value === null || value === undefined || value <= parseFloat(showCondition.value)) result = false;
                } else if (showCondition.type == 'GreaterThanOrEqualTo') {
                    if (value === null || value === undefined || value < parseFloat(showCondition.value)) result = false;
                } else if (showCondition.type == 'LessThan') {
                    if (value === null || value === undefined || value >= parseFloat(showCondition.value)) result = false;
                } else if (showCondition.type == 'LessThanOrEqualTo') {
                    if (value === null || value === undefined || value > parseFloat(showCondition.value)) result = false;
                } else if (showCondition.type == 'InList') {
                    if (showCondition.value.indexOf(value) == -1) result = false;
                } else if (showCondition.type == 'NotInList') {
                    if (value === undefined || value === null || showCondition.value.indexOf(value) > -1) result = false;
                } else if (showCondition.type == 'RiskStateInList') {
                    if (value && showCondition.value.indexOf(value.State) == -1) result = false;
                } else if (showCondition.type == 'RiskStateNotInList') {
                    if (value && showCondition.value.indexOf(value.State) > -1) result = false;
                } else if (showCondition.type == 'ListHasValue') {
                    if (value.indexOf(showCondition.value) == -1) result = false;
                } else if (showCondition.type == 'ListDoesNotHaveValue') {
                    if (value.indexOf(showCondition.value) > -1) result = false;
                } else if (showCondition.type == 'PropertyEqualTo') {
                    if (value === null || value === undefined || value[showCondition.property] === null || value[showCondition.property] === undefined || value[showCondition.property] !== showCondition.value) result = false;
                } else if (showCondition.type == 'PropertyNotEqualTo') {
                    if (value == null || value[showCondition.property] === undefined || value[showCondition.property] === showCondition.value) result = false;
                } else if (showCondition.type == 'HasValue') {
                    if (
                        value === undefined ||
                        value === null ||
                        value === ""
                    ) result = false;
                } else if (showCondition.type == "HasNoValue") {
                    if (value !== undefined &&
                        value !== null &&
                        value !== ""
                    ) result = false;
                } else if (showCondition.type == 'GreaterThanZero') {
                  if (
                    value === undefined ||
                    value === null ||
                    value < 1
                  ) result = false;
                }
            });

            if (showResult == false) showResult = result;
        });
    } catch (e) {
        return false;
    }

    if (isSubFormRule && formState && showResult == false) {
        formState[controlName] = null;
    }


    return showResult;
};
